export default "__VITE_ASSET__vJrdTXAe__"